export const ADD_UPLOADING_FILE = "ADD_UPLOADING_FILE";
export const REMOVE_UPLOADING_FILE = "REMOVE_UPLOADING_FILE";
